import { render } from "./AssetMemberListItem.vue?vue&type=template&id=1804b8e3"
import script from "./AssetMemberListItem.vue?vue&type=script&lang=js"
export * from "./AssetMemberListItem.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__